import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";

import { UIModal, UITextarea } from "../../../../ui";

import "./ResolveReportModal.scss";

const ResolveReportModal = ({
  open,
  labels,
  submitting = false,
  onClose,
  onConfirm,
}) => {
  const [comment, setComment] = useState("");

  useEffect(() => {
    if (!open) {
      setComment("");
    }
  }, [open]);

  const handleClose = () => {
    if (submitting) return;
    onClose();
  };

  const handleConfirm = () => {
    if (submitting) return;
    onConfirm?.({
      comment: comment.trim(),
      imageUrls: [],
      imageUrl: null,
    });
  };

  return (
    <UIModal
      open={open}
      type="success"
      title={labels.title}
      description={labels.description}
      cancelLabel={labels.cancel}
      confirmLabel={labels.confirm}
      onClose={handleClose}
      onCancel={handleClose}
      onConfirm={handleConfirm}
      cancelButtonProps={{ disabled: submitting }}
      confirmButtonProps={{ disabled: submitting, loading: submitting }}
      PaperProps={{ className: "resolve-report-modal" }}
      maxWidth="sm"
      fullWidth
    >
      <Box className="resolve-report-modal__fields" aria-busy={submitting}>
        <UITextarea
          name="resolveComment"
          label={labels.commentLabel}
          value={comment}
          disabled={submitting}
          onChange={(event) => {
            setComment(event?.target?.value ?? "");
          }}
          placeholder={labels.commentPlaceholder}
          minRows={3}
        />
      </Box>
    </UIModal>
  );
};

ResolveReportModal.propTypes = {
  open: PropTypes.bool.isRequired,
  labels: PropTypes.shape({
    title: PropTypes.node.isRequired,
    description: PropTypes.node.isRequired,
    commentLabel: PropTypes.node.isRequired,
    commentPlaceholder: PropTypes.node.isRequired,
    cancel: PropTypes.node.isRequired,
    confirm: PropTypes.node.isRequired,
  }).isRequired,
  submitting: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

ResolveReportModal.defaultProps = {
  submitting: false,
};

export default ResolveReportModal;
